var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{pre:true},[_vm._v("<script type=\"text/javascript\">\n    var event = event || window.event;\n    alert(\"坐标：[\" + event.clientX + \", \" + event.clientY + \"]\")\n</script>\n    ")])}
var staticRenderFns = []

export { render, staticRenderFns }